import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Slot } from '../slot';
import { formStyles } from './styles/form.styles';
import type { FormPropsInterface } from './types/form.types';

/**
 * An HTML [form element](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form).
 * The component itself does nothing other than provide layout for nested form components.
 *
 * @related ['FormActions']
 * @since 8.0.0
 */
export const Form = forwardRef<HTMLFormElement, FormPropsInterface>(
  (props: FormPropsInterface, forwardedRef) => {
    const { asChild = false, className, css: cssProp, ...rest } = props;
    const styles = css(formStyles, cssProp);
    const Component = asChild ? Slot : 'form';
    return (
      <Component
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Form"
        className={cx('c11n', styles, className)}
        {...rest}
      />
    );
  },
);

Form.displayName = 'Form';
